import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { eMessageActions } from '@/actions/trading/emessage.action'
import { FLASH_TYPE as types } from '@/constants/app';
import { Icons } from '@/configurations';
import { SERVICES_RESP } from '@/configurations';
import { PARAMS } from '@/constants/params';

class EMessageDialog extends React.Component {
    constructor(props) {
        super(props)
        this.state ={
          result:'showTips',
          isLoading:false
        }
    }

    submit(){
      this.setState({
        isLoading:true
      })
      const {data, currentTradingAccount, language, clientID } = this.props
      const { tradingAccSeq } = currentTradingAccount;
      if(data && data.length > 0){
        let messageID = ''
        let messageIDList = []
        data.map((item,index) =>{
          messageIDList.push(item.messageID)
          if(index === data.length-1){
            messageID += item.messageID 
          }else{
            messageID += item.messageID +','

          }
        })
        let params = {
          [PARAMS.CLIENT_ID]: clientID,
          [PARAMS.TRADING_ACCOUNT_ID]: clientID,
          [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
          [PARAMS.LANGUAGE]: language.lang,
          [PARAMS.MESSAGE_ID]: messageID,
        }
        this.props.deleteEMessage(params, res => {
          this.setState({
            isLoading:false
          })
          if (res.status === SERVICES_RESP.STATUS_OK) {
            if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
              if(res.result.successList.length !== 0 ){
                // if(re.result.successList === messageIDList){
                // }
                this.setState({ 
                  result:'success'
                })
              }else{
                this.setState({ 
                  result:'fail'
                })
              }
            } else {
              this.setState({ 
                result:'fail'
              })
            }
          }
        })
      }
    }

    componentDidMount(){
      this.setState({
        result:'showTips'
      })
    }

    render() {
        const { type, isMobile, language, ...props } = this.props;
        const { result,isLoading } = this.state
        return (
            <React.Fragment>
                <div className={classnames("modals-warning modals-container")}>
                  <div style={{textAlign:'center',paddingTop:'25px'}}>
                  { result === 'success' ? <Icons.changePasswordSuccess />  : (result === 'fail' ? <Icons.fail /> : '') }
                  </div>
                    <div className={result === 'showTips' ? "modals-content" : "modals-tip-content"}>
                        <p>{result === 'success' ? language.deleteSuccess : (result === 'fail' ? language.deleteFailed : language.deleteTips)}</p>
                    </div>
                    <div className={'modals-action'}>
                      {result !== 'success' && <button
                        className="action-cancel"
                        onClick={() => props.onActions(false)}
                        disabled={isLoading}
                        type="button">{language.common_cancel}</button>}
                        <button
                        className="action-yes"
                        onClick={() => result !== 'showTips' ? props.onActions(true) : this.submit()}
                        disabled={isLoading}
                        type="button">{isLoading ? <Icons.Loading /> : language.common_confirm}</button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

EMessageDialog.defaultProps = {

}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    isNeedRefresh: state.refresh.ipoAction
  }),
  dispatch => ({
    deleteEMessage: (p, res) => dispatch(eMessageActions.deleteEMessageAction(p, res)),
  })
)(EMessageDialog)